export const mergeDaysArray = (daysArrays) => {
  return Array(7)
    .fill()
    .map((_, index) => ({
      ...daysArrays.reduce((fullObj, daysItem) => ({ ...fullObj, ...daysItem[index] }), {})
    }));
};
